import $ from 'jquery';

import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class ReportsAddDataElementTour extends TourBase {
	static keyForPersistantDone = UserSettingsKey.REPORTS_ADD_DATA_ELEMENT;

	get id(): string {
		return TourId.REPORTS__ADD_DATA_ELEMENT;
	}

	override get keyForPersistantDone(): string {
		return ReportsAddDataElementTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.RIGHT,
				allowStacked: false,
				attachTo: () => {
					return $('.tox-editor-container div[title="toolbar__group--storybutton"]');
				},
			},
			{
				direction: Direction.LEFT,
				allowStacked: false,
				attachTo: () => {
					return $(
						'.tox-tiered-menu div[role="menu"]:first-child div[role="menuitem"]:last-child',
					);
				},
			},
		];
	}
}
